import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { Prefectures } from "../../assets/data/Constants";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "区分",
    keyword: "class",
    type: "text",
    text: "都道府県補助金",
  },
  {
    title: "請求日",
    keyword: "billingDate",
    type: "date",
    maxDate: new Date(),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
  },
  {
    title: "請求先都道府県名",
    keyword: "billingPrefecture",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Prefectures),
    requiredIcon: true,
    fullWidth: false,
  },
  {
    title: "請求金額",
    keyword: "amt",
    type: "amount",
    requiredIcon: true,
  },
  {
    title: "交付決定日",
    keyword: "paymentConfirmDate",
    type: "date",
    maxDate: new Date(),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
  },
  {
    title: "入金予定日",
    keyword: "depositDueDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
  },
  {
    keyword: "memo",
    type: "node",
    showLine: false,
  },
  {
    keyword: "symbolNo",
    type: "node",
    showLine: false,
  },
];

const headList: any = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

const schema = {
  billingDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  billingPrefecture: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  amt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  paymentConfirmDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  depositDueDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { fakeTableList, headList, schema };
